window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// AOS
import AOS from 'aos';

// import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fSwiper = require("./components/swiper");
const fSlecet2 = require("./components/select2");
const gsapController = require("./components/gsap-controller");
const fWindowScroll = require("./components/window-scroll");
const fSlideToggle = require("./components/slideToggle");
const fAccordion = require("./components/accordions");
const fSelect = require('./components/select');

// const fMapBox = require("./components/mapbox");

// Vue Support Function
import {
    createApp,
    defineAsyncComponent
} from 'vue'

const InitVueComponents = () => {
    // Async components
    const UpdatesPress = defineAsyncComponent(() => import("./vue/updates-press.vue"));
    const MapBox = defineAsyncComponent(() => import("./vue/map-box.vue"));
    // Static Components
    // const StaticComponent = require('./vue/multi-file-component/child-component').default;

    // Init Vue Instance
    const $VueApp = createApp({});
    $VueApp
        .component("updates-press", UpdatesPress)
        .component("mapbox", MapBox)
    // .component("child-component", StaticComponent);
    $VueApp.mount('#vue-space');

}

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    fSmoothScroll();
    fSelect.init();
    fWindowScroll.init();
    fSwiper.init();
    fSlecet2.init();
    fSlideToggle.init();
    (document.getElementById('vue-space')) ? InitVueComponents() : null;
    gsapController.init();
    fAccordion
    // ExampleModule()

    AOS.init({
        offset: 0,
        duration: 1500,
        // anchorPlacement: 'top-center',
        once: true,
    });
    if (document.querySelector(".accordion-list")) {
        const loadAccordion = async () => {
            const fAccordionList = await import('./components/apartments-accordion');
            fAccordionList.init();
        };

        loadAccordion();
    }
});